import moment from 'moment';
import _ from 'underscore';
import parseError from '../../parseError';


const createMeal = async ({ tour, state, contextMenuSelection, userId, addMeal, Toast, updateState}) => {
  let { tourId } = await tour;
  const { itemDetails } = state;
  let { mealStartTime, mealEndTime } = itemDetails;
  const parameters = {
    startTime: mealStartTime.format('YYYY-MM-DD HH:mm:SS'),
    endTime: mealEndTime.format('YYYY-MM-DD HH:mm:SS'),
    userId
  };

  if (contextMenuSelection === 'Add Tour') {
    // if the meal has a tour
    if (mealStartTime) {
      parameters.tourId = itemDetails.tourId;
    }
  }

  if (contextMenuSelection === 'Edit Tour') {
    parameters.tourId = itemDetails.tourId;
  }

  if (contextMenuSelection === 'Add Assignment'
  || contextMenuSelection === 'Edit Assignment') {
    // when creating a tour as part of newly placed/concurrent/completed assignment
    parameters.tourId = tourId;
  }


  // add meal
  const { resource } = state;
  const date = moment(mealStartTime).format('M/D/YYYY (ddd)');
  let notification = {type: 'success', message: 'Meal Added', description: `For ${resource.name} on ${date}`};
  try {
    await addMeal(parameters);
  }
  catch(error) {
    if (!_.isEmpty(error)) {
      updateState({
        crudError: {
          failedAction: 'addMeal',
          message: parseError(error)
        }
      });
      console.log(error);
      notification = {
        type: 'error',
        message: "Adding Meal Failed",
        description: `For [${resource.name} on ${date}]: ${parseError(error)}`
      };
    }
  }
  Toast(notification);
  // should never refresh on its own, always part of creating a tour, which will handle refresh
}

export default createMeal;



// WEBPACK FOOTER //
// ./src/Components/Schedule/LiveScheduleUpdate/utils/CRUD/meal/createMeal.js